// extracted by mini-css-extract-plugin
export var caption = "PageDataBodyInlineGallery-module--caption--hG7YR";
export var captionActive = "PageDataBodyInlineGallery-module--captionActive--1ZQoT";
export var gallery = "PageDataBodyInlineGallery-module--gallery--ts0Tf";
export var galleryImage = "PageDataBodyInlineGallery-module--galleryImage--C3ITo";
export var gallerySlide = "PageDataBodyInlineGallery-module--gallerySlide--rnb2D";
export var gallerySlides = "PageDataBodyInlineGallery-module--gallerySlides--wkBU2";
export var next = "PageDataBodyInlineGallery-module--next--VI77S";
export var prev = "PageDataBodyInlineGallery-module--prev--rYElv";
export var slidesContainer = "PageDataBodyInlineGallery-module--slidesContainer--5eMsc";